import React from "react";
import "./lock-plug.scss";
import { useTranslation } from "react-i18next";

export default function BonusLockPlug({ text }) {
  const { t } = useTranslation();
  
  return (
    <div className="bonus__lock__plug">
      <p>{t(text)}</p>
    </div>
  );
}
